var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "ca-form" },
      [
        _c(
          "el-form",
          {
            ref: "licenseForm",
            staticClass: "form-container",
            attrs: {
              model: _vm.licenseForm,
              rules: _vm.rules,
              autocomplete: "on",
              "label-position": "left",
              size: "mini",
            },
          },
          [
            _c(
              "div",
              { staticClass: "ca-single-line" },
              [
                _c(
                  "el-form-item",
                  { staticClass: "w-50", attrs: { label: "License Type" } },
                  [
                    _c("VendorLicenseOption", {
                      model: {
                        value: _vm.licenseForm.licenseTypeId,
                        callback: function ($$v) {
                          _vm.$set(_vm.licenseForm, "licenseTypeId", $$v)
                        },
                        expression: "licenseForm.licenseTypeId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { staticClass: "w-50", attrs: { label: "State" } },
                  [
                    _c("el-input", {
                      attrs: {
                        maxlength: "5",
                        placeholder: "NY",
                        required: "",
                      },
                      model: {
                        value: _vm.licenseForm.state,
                        callback: function ($$v) {
                          _vm.$set(_vm.licenseForm, "state", $$v)
                        },
                        expression: "licenseForm.state",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "ca-single-line" },
              [
                _c(
                  "el-form-item",
                  { staticClass: "w-50", attrs: { label: "License Number" } },
                  [
                    _c("el-input", {
                      attrs: {
                        maxlength: "20",
                        placeholder: "License Number",
                        required: "",
                      },
                      model: {
                        value: _vm.licenseForm.licenseNumber,
                        callback: function ($$v) {
                          _vm.$set(_vm.licenseForm, "licenseNumber", $$v)
                        },
                        expression: "licenseForm.licenseNumber",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { staticClass: "w-50", attrs: { label: "Expiration" } },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "date",
                        placeholder: "Select date",
                        format: "yyyy/MM/d",
                        "value-format": "yyyy-MM-d",
                        required: "",
                      },
                      model: {
                        value: _vm.licenseForm.expirationDateString,
                        callback: function ($$v) {
                          _vm.$set(_vm.licenseForm, "expirationDateString", $$v)
                        },
                        expression: "licenseForm.expirationDateString",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "dialog-footer",
        staticStyle: { "text-align": "center", "margin-top": "10px" },
        attrs: { slot: "footer" },
        slot: "footer",
      },
      [
        _c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("Cancel")]),
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
          [_vm._v("Add License")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }